import { useState } from "react";
import { useLanguage } from "../lib/i18n/LanguageContext";
import { Language } from "../lib/i18n/translations";
import { SUPPORTED_LANGUAGES } from "@/lib/constants/languages";

function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const currentLanguage = SUPPORTED_LANGUAGES.find(
    (lang) => lang.code === language,
  );

  const handleLanguageSelect = (langCode: Language) => {
    setLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className="language-switcher relative z-50">
      <div className="relative">
        {/* Toggle Button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="language-toggle flex items-center gap-2 bg-white dark:bg-gray-900 border-1 border-black dark:border-gray-600 px-3 py-2 hover:bg-gray-100 hover:text-black dark:hover:bg-gray-600 dark:hover:text-white transition-colors text-black dark:text-white"
          aria-label="Change language"
        >
          {/* <Globe size={16} /> */}
          <span className="language-current text-xs font-medium">
            {currentLanguage?.code.toUpperCase()}
          </span>
        </button>

        {/* Dropdown */}
        {isOpen && (
          <div className="language-dropdown absolute top-full right-0 mt-1 bg-white dark:bg-gray-800 border-2 border-black dark:border-gray-600 shadow-lg min-w-[140px]">
            {SUPPORTED_LANGUAGES.map((lang) => (
              <button
                key={lang.code}
                onClick={() => handleLanguageSelect(lang.code)}
                className={`language-option w-full text-left px-3 py-2 text-sm flex items-center gap-2 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors text-black dark:text-white ${
                  language === lang.code
                    ? "bg-gray-50 dark:bg-gray-700 font-medium"
                    : ""
                }`}
              >
                <span className="flag">{lang.flag}</span>
                <span className="lang-name">{lang.name}</span>
                {language === lang.code && (
                  <span className="current-indicator ml-auto text-xs">✓</span>
                )}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Backdrop to close dropdown */}
      {isOpen && (
        <div
          className="language-backdrop fixed inset-0 -z-10"
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
}

export default LanguageSwitcher;
